
import Loader from 'modules/common/components/Loader';
import discountsStrings from '../../strings';
import type { DiscountItem } from '../../types/discount.types';
import DiscountCard from '../DiscountCard/DiscountCard';
import DiscountOffersEmptyState from '../DiscountOffersEmptyState/DiscountOffersEmptyState';
import {
  DiscountCardsGrid,
  DiscountEmptyState,
  DiscountsLoaderWrapper,
  LoadMoreButton,
  LoadMoreWrapper,
} from '../../views/Discounts.style';

interface DiscountCardGridProps {
  discounts?: DiscountItem[];
  isLoading: boolean;
  isError: boolean;
  onAction: (discount: DiscountItem, actionType: string) => void;
  onCreateOffer?: () => void;
  onCreateBundle?: () => void;
  hasMore?: boolean;
  isLoadingMore?: boolean;
  onLoadMore?: () => void;
}

const DiscountCardGrid = ({
  discounts,
  isLoading,
  isError,
  onAction,
  onCreateOffer,
  onCreateBundle,
  hasMore = false,
  isLoadingMore = false,
  onLoadMore,
}: DiscountCardGridProps) => {
  if (isLoading) {
    return (
      <DiscountsLoaderWrapper>
        <Loader />
      </DiscountsLoaderWrapper>
    );
  }

  if (isError) {
    return <DiscountEmptyState>{discountsStrings.loadError}</DiscountEmptyState>;
  }

  if (!discounts?.length) {
    if (onCreateOffer) {
      return (
        <DiscountOffersEmptyState onCreateOffer={onCreateOffer} onCreateBundle={onCreateBundle} />
      );
    }
    return <DiscountEmptyState>{discountsStrings.emptyList}</DiscountEmptyState>;
  }

  return (
    <>
      <DiscountCardsGrid>
        {discounts.map(discount => (
          <DiscountCard key={discount.id} discount={discount} onAction={onAction} />
        ))}
      </DiscountCardsGrid>
      {hasMore ? (
        <LoadMoreWrapper>
          <LoadMoreButton type="button" onClick={onLoadMore} disabled={isLoadingMore}>
            {isLoadingMore ? <Loader width={18} height={18} thickness={3} /> : discountsStrings.loadMore}
          </LoadMoreButton>
        </LoadMoreWrapper>
      ) : null}
    </>
  );
};

export default DiscountCardGrid;
